<template lang="html">
  <h3 style="text-align: center">Clientes</h3>
</template>

<script>
export default {
  data(){
    return{
      clients:[]
    }
  },
  methods:{

  },
  mounted(){
    try {
      this.$http.get('app/clients',)
      .then(function(response){
      }, function(response){
        if(typeof response.body.errors[0].details != "object"){
          alert(response.body.errors[0].details);
        }else{
          let message = []
          for(var key in response.body.errors[0].details){
            message.push(response.body.errors[0].details[key])
          }
          alert(message);
        }
      })
      } catch (e) {
        alert(e.message)
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/clients/Index.vue